// extracted by mini-css-extract-plugin
module.exports = {"tags":"tags-module--tags--CY1-e","tags__item":"tags-module--tags__item--2mELd"};